import { Typography } from "@components/organisms/profilePhoto/profilePhoto.styled";

import { ProfileStatsProps } from "./profile-stats.type";
import { Container } from "./profileStats.styled";

import { ReactComponent as Star } from "@assets/images/star/star.svg";

const ProfileStats = ({ title, reviewStat }: ProfileStatsProps) => {
  return (
    <Container>
      <Star />
      <Typography> {reviewStat} </Typography>
      <Typography> {title} </Typography>
    </Container>
  );
};

export default ProfileStats;
